import React, {useState, useEffect} from 'react';
import Chart from 'react-apexcharts';
import Title from '../../../../components/Title';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import DrawTable from '../../../../components/DrawTable';
import DataCard from '../DataCard';
import {
  AnnotationsMonth,
  AnnotationsPremiums,
  getMonthName,
  getPlanName,
  months,
  premiuns,
  responsive,
  responsiveCards,
  responsiveMedium,
  returnTotalValues,
  returnTotalValuesPremium,
  returnValuesPremium,
  returnValuesTotalPremium,
} from '../../service/utils';
import dashboardService from '../../service';
import {KeyboardDatePicker} from '@material-ui/pickers';
import DrawTableDash from '../../../../components/DrawTableDash';
import {GetAppOutlined} from '@material-ui/icons';
import {styles} from './styles';
import api from '../../../../core/api';
import {CustomSelect} from './components/CustomSelect';
import {MetricCell} from './components/MetricCell';

const TopPartnersItem = () => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [topPartners, setTopPartnerData] = useState([]);

  const [filters, setFilters] = useState({
    platform: null,
    currentAccountType: null,
  });

  const GetData = async () => {
    setLoading(true);

    const response = await dashboardService.getTopPartners({
      startDate,
      endDate,
      filters: {
        platform: filters.platform || null,
        currentAccountType: filters.currentAccountType || null,
      },
    });
    setTopPartnerData(response.data || []);

    setLoading(false);
  };

  useEffect(() => {
    GetData();
  }, [startDate, endDate, filters]);

  return (
    <div
      style={{
        margin: 15,
        marginTop: 25,
        padding: 20,
        backgroundColor: '#fff',
        borderRadius: 10,
      }}>
      <div>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          style={{marginBottom: 20}}>
          Top 20 Parceiros
        </Typography>
        <div style={styles.flex}>
          <CustomSelect
            title="Plataforma"
            values={[
              {value: null, label: 'Todos'},
              {value: 'android', label: 'Android'},
              {value: 'ios', label: 'IOS'},
            ]}
            value={filters.platform}
            setValue={event =>
              setFilters({
                ...filters,
                platform: event,
              })
            }
          />

          <CustomSelect
            title="Assinantes"
            values={[
              {value: null, label: 'Todos'},
              {value: 'subscriber', label: 'Sim'},
              {value: 'free', label: 'Não'},
            ]}
            value={filters.currentAccountType}
            setValue={event =>
              setFilters({
                ...filters,
                currentAccountType: event,
              })
            }
          />

          <div style={styles.flexEnd}>
            <div style={styles.datePicker}>
              <KeyboardDatePicker
                value={startDate}
                format="DD/MM/YYYY"
                maxDate={endDate}
                onChange={date => {
                  const newDate = new Date(date);

                  if (newDate > endDate) {
                    setEndDate(newDate);
                  }

                  setStartDate(newDate);
                }}
              />
            </div>

            <div style={styles.datePicker}>
              <KeyboardDatePicker
                value={endDate}
                format="DD/MM/YYYY"
                minDate={startDate}
                onChange={date => {
                  const newDate = new Date(date);

                  if (newDate < startDate) {
                    setStartDate(newDate);
                  }

                  setEndDate(newDate);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="flex-col center-a center-b">
          <CircularProgress size={100} />
        </div>
      ) : (
        <Table style={{width: '100%'}}>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Views</TableCell>
              <TableCell>Salvos</TableCell>
              <TableCell>Playlist</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {topPartners.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="body2" color="textSecondary">
                    Nenhum parceiro encontrado
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              topPartners.map((item, index) => (
                <TableRow key={item.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.views}</TableCell>
                  <TableCell>{item.favorites || '-'}</TableCell>
                  <TableCell>{item.playlists || '-'}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default TopPartnersItem;
